import React from 'react';
import { graphql, gql, compose } from 'react-apollo';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Loader from '../../../../components/Loader/Loader'
import s from './AboutUsBlock1.css';
import AboutUsFormBlock1 from '../../../../components/siteadmin/AboutUsPageSetting/AboutUsFormBlock1'
import getAboutUsPageSettings from './getAboutUsPageSettings.graphql';

class AboutUsBlock1 extends React.Component {

    static defaultProps = {
        data: {
            loading: false,
            getAboutUsPage: []
        }
    };

    render() {
        const { data: { loading, getAboutUsPage }, title } = this.props
        let settingsCollection = {}
        
        if(loading){
            return <Loader type={"text"} />;
        }

        if (getAboutUsPage && getAboutUsPage.length > 0) {
            getAboutUsPage.map((item, key) => {
                settingsCollection[item.name] = item.value
            });
        }

        return <AboutUsFormBlock1 initialValues={settingsCollection} title={title} />
    }
}

export default compose(
    withStyles(s),
    graphql(getAboutUsPageSettings, {
        options: {
            fetchPolicy: 'network-only',
            ssr: false
        }
    }),
)(AboutUsBlock1);